import PropTypes from 'prop-types'
import { createContext, useContext } from 'react'
import { useAuth } from 'services/hook/Auth'

const AuthContext = createContext()
const authToken = { token: null }

const useAuthContext = () => useContext(AuthContext)

const AuthProvider = ({ children }) => {
    const auth = useAuth()
    authToken.token = auth.user == null ? null : (auth.token || null)
    
    const signOut = () => {
        auth.logout && auth.logout();
    }
    
    return <AuthContext.Provider value={{ ...auth, signOut }}>{children}</AuthContext.Provider>
}

AuthProvider.propTypes = {
    children: PropTypes.node
}

export { useAuthContext, AuthProvider, authToken }

